import React, { JSX } from "react";
import CloseSvg from "../../assets/taiga-uikit/icons/close.svg?react";
import InformationSvg from "../../assets/taiga-uikit/icons/information.svg?react";
import VerifySvg from "../../assets/taiga-uikit/icons/verify.svg?react";
import Warning2Svg from "../../assets/taiga-uikit/icons/warning-2.svg?react";
import { Link } from "../../components/link/link";
import { Text } from "../../components/texts/text";
import { _size, _sizeText, _style } from "../../core/core";
import { useLocalStorage } from "../../shared/hooks/useLocalStorage";
import { Button } from "../button/button";
import "./Push.css";

interface PushProps {
  id: string;
  status?: "info" | "warning" | "success" | "error";
  title?: string;
  text?: string | React.ReactNode;
  date?: string;
  link?: string;
  shadow?: boolean;
  is_close_btn?: boolean;
  is_icon?: boolean;
}

export const Push: React.FC<PushProps> = ({
  id,
  status = "info",
  title,
  text,
  date,
  link,
  shadow = false,
  is_close_btn = true,
  is_icon = true,
  ...props
}) => {
  const [isClose, setIsClose] = useLocalStorage(`push_off-${id}`, true);

  const getIcon = (): JSX.Element | null => {
    switch (status) {
      case "info":
        return <InformationSvg />;
      case "warning":
        return <Warning2Svg />;
      case "success":
        return <VerifySvg />;
      case "error":
        return <Warning2Svg />;
      default:
        return null;
    }
  };

  return (
    <>
      {isClose && (
        <div
          key={id}
          className={`push push-${status} push-shadow-${shadow}`}
          {...props}
        >
          {is_icon && <div className="push-icon">{getIcon()}</div>}
          <div className="push-body">
            {title && (
              <div className="push-group">
                <Text size={_sizeText.sbold}>{title}</Text>
              </div>
            )}
            {text && (
              <div className="push-text">
                <Text size={_sizeText.s}>{text}</Text>
              </div>
            )}
            {link && (
              <Link link={link} style={_style.primary}>
                Ссылка
              </Link>
            )}
          </div>
          {is_close_btn && (
            <Button
              onClick={() => setIsClose(false)}
              style={_style.clear}
              size={_size.XS}
            >
              <CloseSvg />
            </Button>
          )}
        </div>
      )}
    </>
  );
};
